import { useContext, useState } from "react"
import QueryContext from "../../Base/Context"
import ResultTabPanelItemsTable from "../../Base/Result/TabPanels/ItemsTable"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ResultTabPanelJson from "../../Base/Result/TabPanels/Json"
import 'react-pivottable/pivottable.css';
import { ItemsTableDefault } from "../../../../Various/ItemsTable/ItemsTable";

function ChatMessages({ messages = [], height = "350px", ...props }) {
    const [sortColumns, setSortColumns] = useState([])
    var [filterColumns, setFilterColumns] = useState({})
    const [itemActive, setItemActive] = useState(null)

    const clickHandler = (item, column, index, itemOrig) => {
        console.log("this", itemOrig)
        setItemActive(itemOrig)
    }

    const tableData = Array.isArray(messages) ? messages.map(x => {
        const messageType = x.message?.additional_kwargs?.message_type || 'unknown'
        const messageData = x.message?.additional_kwargs?.message_data || {}

        // Single response format: courses live under message_data.all_courses, unwrap _source
        const recommended_courses = (messageData.all_courses || [])
            .filter(course => course && course._source)
            .map(course => course._source)

        return {
            content: x.message?.content,
            message_type: messageType,
            recommended_courses
        }
    }) : []

    return (<>
        <div style={{ height }} className='content'>
            <ItemsTableDefault
                clickHandler={clickHandler}

                tableData={tableData}
                sortColumns={sortColumns}
                setSortColumns={setSortColumns}
                noMemo={true}
                filterColumns={filterColumns}
                setFilterColumns={setFilterColumns}

                {...props}
            />
        </div>
        <br />
        {itemActive ?
            ( itemActive.message_type === "recommendations") ?
                <div><ul>
                    {itemActive.recommended_courses.map( (course, index) =>
                            <li key={index}>
                                {course.client_value} - {course.title_value}
                                <br />
                                URL: {course.url_value}
                                <br/>
                                Item-Id: {course.item_id}
                            </li>
                        )}
                </ul></div>
                :
                <p>{itemActive.content}</p>
            : <div>nothing selected</div>
        }
        </>)
}

export default function EdufindChatsResult() {
    const { response } = useContext(QueryContext)
    const [itemActive, setItemActive] = useState(null)

    const clickHandler = (item, column, index, itemOrig) => {
        console.log(itemOrig)
        setItemActive(itemOrig)
    }

    return <>
        <Tabs>
            <TabList>
                {response &&
                    <>
                        <Tab>Hits ({response.hits.hits.length})</Tab>
                    </>
                }
                <Tab>JSON</Tab>
            </TabList>
            {response &&
                <>
                    <TabPanel>
                        <ResultTabPanelItemsTable
                            height={"350px"}
                            clickHandler={clickHandler}
                            fn_dataTransform={(response) => response.hits.hits.map(x => {
                                return {
                                    "chat_id": x.fields['payload.chat_id'][0],
                                    timestamp: x.fields['timestamp'][0],
                                    messages: x.inner_hits.messages.hits.hits.map(message => {
                                        return {
                                            "timestamp": message._source.timestamp,
                                            "message": message._source.payload.message,
                                            "role": message._source.payload.role,
                                        }
                                    })
                                }
                            })
                            }
                        />
                    </TabPanel>
                </>
            }
            <TabPanel>
                <ResultTabPanelJson />
            </TabPanel>
        </Tabs>
        {itemActive ? <ChatMessages messages={itemActive.messages} key={itemActive.chat_id} /> : <div>nothing selected</div>}
    </>

}
